var _requestPaymentExtensionMutation;

import { graphql, commitMutation } from 'react-relay';
const requestPaymentExtensionMutation = _requestPaymentExtensionMutation !== void 0 ? _requestPaymentExtensionMutation : _requestPaymentExtensionMutation = require("./__generated__/requestPaymentExtensionMutation.graphql");

function commit(environment, _ref) {
  let {
    relationshipId,
    invoiceId,
    netTerms
  } = _ref;
  return new Promise(resolve => commitMutation(environment, {
    mutation: requestPaymentExtensionMutation,
    variables: {
      relationshipId,
      invoiceId,
      netTerms
    },
    onCompleted: function requestPaymentExtensionCompleted(response) {
      resolve(response.requestPaymentExtension);
    },
    onError: () => resolve(undefined)
  }));
}

export default commit;